import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Switch from 'carbon-react/lib/components/switch';
import Typography from 'carbon-react/lib/components/typography';

import { FormattedMessage } from '@futrli/localisation';

import * as styles from '../my-profile.scss';
import { StoreState } from '../../core/types';
import { EnableMfa } from './enable-mfa';
import { DisableMfa } from './disable-mfa';

export const VERIFICATION_CODE_LENGTH = 6;

export const MultiFactorAuth = () => {
  const [switchClicked, setSwitchClicked] = useState(false);

  const { user } = useSelector((state: StoreState) => ({
    user: state.authReducers.authenticatedUser
  }));

  const mfaIsDisabled = user.preferredMFA === 'NOMFA';

  const handleSwitchClick = (value: boolean) => {
    setSwitchClicked(value);
  };

  return (
    <div className={styles.container} style={switchClicked ? {} : { height: 130 }}>
      {switchClicked ? (
        mfaIsDisabled ? (
          <EnableMfa handleSwitchClick={handleSwitchClick} />
        ) : (
          <DisableMfa handleSwitchClick={handleSwitchClick} />
        )
      ) : (
        <>
          <Typography mb="15px" fontWeight="700" fontSize="18px">
            <FormattedMessage id="my_profile.multi_factor_auth" defaultMessage="Multi-factor authentication" />
          </Typography>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Switch id="multi-factor-auth-switch" checked={!mfaIsDisabled} onChange={() => setSwitchClicked(true)} />
            <label htmlFor="multi-factor-auth-switch">
              {mfaIsDisabled ? (
                <Typography as="span" fontWeight="500" ml="8px" mb="0">
                  <FormattedMessage
                    id="my_profile.multi_factor_auth_off"
                    defaultMessage="Multi-factor authentication is OFF"
                  />
                </Typography>
              ) : (
                <Typography as="span" fontWeight="500" ml="8px" mb="0">
                  <FormattedMessage
                    id="my_profile.multi_factor_auth_on"
                    defaultMessage="Multi-factor authentication is ON"
                  />
                </Typography>
              )}
            </label>
          </div>
        </>
      )}
    </div>
  );
};
